const config = {
  id: 15,
  name: '自定义菜单',
  type: 1,
  module_code: 'custom_menu',
  icon: 'icon-tms-customer_menu',
  font_icon: '&#xe601;',
  style_type: 1,
  link_type: 1,
  link_data: [],
  property_data: {
    is_icon_show: 0,
    icon_url: '',
    name: '自定义菜单',
    sub_title: '',
    radius_top: 0,
    radius_bottom: 0,
    margin_num: 0,
    link_data: '',
  }
};
export default config;